import { isConnectivityFailure } from '@/lib/service-failure';
import type { ApiError } from '@/types/api.types';

/**
 * Turns a failed access check into the message shown under the form, or null when there is nothing for
 * the field to say.
 *
 * Null means the portal could not reach the backend at all. That case has one standardised message for
 * the whole portal (PP-028 / proweb-74) and `ServiceUnavailableBanner` carries it above the form, so
 * the field does not restate it in words of its own. A backend that answered and refused still reports
 * its own non-technical text, and no server detail beyond that ever reaches the screen.
 */
export function toLoginErrorMessage(error: ApiError | null): string | null {
  if (error === null) {
    return null;
  }

  if (isConnectivityFailure(error)) {
    return null;
  }

  // The backend answered, but with a fault rather than a verdict. Nothing from it is shown.
  return error.status !== undefined && error.status >= 500 ? SERVICE_FAULT_MESSAGE : error.message;
}

/** A 5xx that is not a connectivity failure: the backend answered and something inside it broke. */
export const SERVICE_FAULT_MESSAGE =
  'The service is temporarily unavailable. Please try again later.';
